import { render, staticRenderFns } from "./MenuEditUser.vue?vue&type=template&id=2f2502cd&scoped=true&lang=pug&"
import script from "./MenuEditUser.vue?vue&type=script&lang=ts&"
export * from "./MenuEditUser.vue?vue&type=script&lang=ts&"
import style0 from "./MenuEditUser.vue?vue&type=style&index=0&id=2f2502cd&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2502cd",
  null
  
)

export default component.exports